import { Skeleton } from "@/components/ui";

export const GoalsSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1"
      data-testid="goals-skeleton"
    >
      <div className="flex flex-col gap-1">
        <Skeleton className="h-[16px] w-24" />
      </div>
    </div>
  );
};
